import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-arrow",
  "use": "icon-menu-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-menu-arrow\">\n    <path d=\"M13.428 12.511l-3.81-3.81a.75.75 0 0 1 1.062-1.059l4.34 4.34a.75.75 0 0 1 0 1.06l-4.489 4.49A.75.75 0 1 1 9.47 16.47l3.958-3.96v.001z\" fill-rule=\"nonzero\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol